import { render, staticRenderFns } from "./CutOffTimesOverview.vue?vue&type=template&id=5b8f40b4&"
import script from "./CutOffTimesOverview.vue?vue&type=script&lang=js&"
export * from "./CutOffTimesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports